import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { questions } from "../data/questions";
import { calcScores } from "../lib/calcScores";
import CoupangAdBlock from "../components/common/CoupangAdBlock";

import "../styles/test.css";

const SCALE_OPTIONS = [
  { value: 1, label: "전혀 그렇지 않다" },
  { value: 2, label: "별로 그렇지 않다" },
  { value: 3, label: "보통이다" },
  { value: 4, label: "대체로 그렇다" },
  { value: 5, label: "매우 그렇다" },
];

function TestPage() {
  const [answers, setAnswers] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const listRef = useRef(null);
  const navigate = useNavigate();

  const QUESTIONS_PER_PAGE = 13;
  const totalPages = Math.ceil(questions.length / QUESTIONS_PER_PAGE);

  const startIndex = (currentPage - 1) * QUESTIONS_PER_PAGE;
  const endIndex = startIndex + QUESTIONS_PER_PAGE;
  const visibleQuestions = questions.slice(startIndex, endIndex);

  const handleChange = (questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: Number(value),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const scores = calcScores(questions, answers);
    navigate("/result", { state: { scores } });
  };

  const isCurrentPageAnswered = visibleQuestions.every(
    (q) => answers[q.id] != null
  );
  const allAnswered = questions.every((q) => answers[q.id] != null);
  const answeredCount = Object.keys(answers).length;
  const progressRatio = answeredCount / questions.length;

  const scrollToTop = () => {
    // 질문 리스트 박스 안 스크롤
    if (listRef.current) {
      listRef.current.scrollTop = 0;
    }
    // 혹시 페이지 전체가 스크롤되는 레이아웃일 경우까지 커버
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleNextPage = () => {
    if (currentPage < totalPages && isCurrentPageAnswered) {
      setCurrentPage((prev) => prev + 1);
      scrollToTop();
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      scrollToTop();
    }
  };

  return (
    <div className="test-page">
      <div className="test-card">
        <header className="test-header">
          <span className="test-logo">mmbbttii</span>
          <span className="test-step">
            페이지 {currentPage} / {totalPages}
          </span>
        </header>

        {/* 진행률 */}
        <section className="test-progress">
          <div className="test-progress-top">
            <span className="test-progress-label">진행률</span>
            <span className="test-progress-count">
              {answeredCount} / {questions.length} 문항
            </span>
          </div>
          <div className="test-progress-bar">
            <div
              className="test-progress-bar-fill"
              style={{ width: `${progressRatio * 100}%` }}
            />
          </div>
        </section>

        {/* 안내 문구 */}
        <section className="test-intro">
          <h1 className="test-title">지금의 너를 가볍게 체크해봐요.</h1>
          <p className="test-subtitle">
            각 문항에 대해 지금의 나와 가장 가까운 정도를 선택해 주세요.
          </p>
        </section>

        {/* 질문들 */}
        <form onSubmit={handleSubmit} className="test-form">
          <div className="test-questions" ref={listRef}>
            {visibleQuestions.map((q, index) => {
              const globalIndex = startIndex + index + 1;
              const isMiddle =
                index === Math.floor(visibleQuestions.length / 2) - 1; // 페이지 중간쯤

              return (
                <React.Fragment key={q.id}>
                  <div className="test-question">
                    <p className="test-question-number">Q{globalIndex}</p>
                    <p className="test-question-text">
                      <strong>{q.text}</strong>
                    </p>

                    <div className="test-answer-group">
                      {SCALE_OPTIONS.map((opt) => {
                        const selected = answers[q.id] === opt.value;
                        return (
                          <label
                            key={opt.value}
                            className={
                              "test-answer-option" +
                              (selected ? " test-answer-option--selected" : "")
                            }
                          >
                            <input
                              type="radio"
                              className="test-answer-input"
                              name={q.id}
                              value={opt.value}
                              checked={selected}
                              onChange={(e) =>
                                handleChange(q.id, e.target.value)
                              }
                            />
                            <span className="test-answer-label">
                              {opt.label}
                            </span>
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  {/* ✅ 페이지 중간쯤에 광고 3개 나란히 */}
                  {isMiddle && (
                    <div className="test-ad-row">
                      <CoupangAdBlock
                        adKey="robotCleanerA"
                        placement="test-left"
                      />
                      <CoupangAdBlock
                        adKey="robotCleanerB"
                        placement="test-center"
                      />
                      <CoupangAdBlock
                        adKey="robotCleanerC"
                        placement="test-right"
                      />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>

          {/* 하단 네비게이션 */}
          <div className="test-actions">
            <div className="test-actions-left">
              {currentPage > 1 && (
                <button
                  type="button"
                  className="test-button test-button--ghost"
                  onClick={handlePrevPage}
                >
                  이전
                </button>
              )}
            </div>

            <div className="test-actions-right">
              {currentPage < totalPages && (
                <button
                  type="button"
                  className="test-button"
                  onClick={handleNextPage}
                  disabled={!isCurrentPageAnswered}
                >
                  다음
                </button>
              )}
              {currentPage === totalPages && (
                <button
                  type="submit"
                  className="test-button"
                  disabled={!allAnswered}
                >
                  결과 보기
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default TestPage;
